//type
import { signupReqType } from './type/SignupType';
import { signupResType } from './type/SignupType';

//apifetch
import axios from 'axios';

//translate
import i18n from '../../translate/i18n';

//server path
const baseURL = process.env.REACT_APP_API_BASE_URL;

export const PostSignup = async (data: signupReqType) => {
  try {
    const response = await axios.post<signupResType>(`${baseURL}/auth/register`, data, {
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': i18n.language,
      },
    }); 
    return response.data; 
  } catch (error: any) {
    console.error(error.response?.data || error.message);
    throw error;
  }
};